<template>
  <aside class="app-sidebar">
    <ul class="app-menu">
      <li>
        <router-link :to="{ name: 'dashboard' }" class="app-menu__item">
          <i class="bi bi-speedometer app-menu__icon"></i>
          <span class="app-menu__label">หน้าหลัก</span>
        </router-link>
      </li>
      <!-- <li>
        <router-link :to="{ name: 'doctor' }" class="app-menu__item">
          <i class="bi bi-people app-menu__icon"></i>
          <span class="app-menu__label">แพทย์</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'dentist' }" class="app-menu__item">
          <i class="bi bi-people app-menu__icon"></i>
          <span class="app-menu__label">ทันตแพทย์</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'pharmacist' }" class="app-menu__item">
          <i class="bi bi-people app-menu__icon"></i>
          <span class="app-menu__label">เภสัชกร</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'nurse' }" class="app-menu__item">
          <i class="bi bi-people app-menu__icon"></i>
          <span class="app-menu__label">พยาบาล</span>
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'publichealthtechnicalofficer' }" class="app-menu__item">
          <i class="bi bi-people app-menu__icon"></i>
          <span class="app-menu__label">นักวิชาการสาธารณสุข</span>
        </router-link>
      </li> -->
      <li>
        <router-link :to="{ name: 'opduser' }" class="app-menu__item">
          <i class="bi bi-people app-menu__icon"></i>
          <span class="app-menu__label">ผู้ใช้งานระบบ</span>
        </router-link>
      </li>

      <div v-if="isAdmin">
        <!-- <li>
          <router-link :to="{ name: 'checkerrors' }" class="app-menu__item">
            <i class="bi bi-exclamation-circle app-menu__icon"></i>
            <span class="app-menu__label text-danger">Check ERRORS!</span>
          </router-link>
        </li> -->
        <li>
          <router-link :to="{ name: 'SearchVn' }" class="app-menu__item">
            <i class="bi bi-search app-menu__icon"></i>
            <span class="app-menu__label">Search VN</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'LabSecret' }" class="app-menu__item">
            <i class="bi bi-search app-menu__icon"></i>
            <span class="app-menu__label">Lab Secret</span>
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'DoctorQueue' }" class="app-menu__item">
            <i class="bi bi-list-task app-menu__icon"></i>
            <span class="app-menu__label">DoctorQueue</span>
          </router-link>
        </li>
      </div>
    </ul>
  </aside>
</template>

<script>
import usersService from "@/services/users-service";
import { mapState } from "vuex";
export default {
  data() {
    return {
      account: {},
    };
  },
  methods: {
    async getUser(id) {
      try {
        const res = await usersService.get(id);
        this.account = res.data.account;
      } catch (error) {
        this.showError(error);
        localStorage.removeItem("vuex");
      }
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    isAdmin() {
      const role = this.$store.state.role || this.user?.role || this.user?.roles || localStorage.getItem("role");
      const adminRoles = ["admin", "super_admin"];

      if (Array.isArray(role)) {
        return role.some((item) => adminRoles.includes(String(item).toLowerCase()));
      }

      return adminRoles.includes(String(role || "").toLowerCase());
    },
    ...mapState(["app", "user"]),
  },
  created() {
    if (this.user?.id) {
      this.getUser(this.user.id);
    }
  },
};
</script>

<style scoped>
.app-sidebar__user {
  display: block;
  margin-bottom: 0px;
}

.app-sidebar {
  padding-top: 52px;
}
</style>
